import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { formatPageNumber } from "../utils";
import type { PaginationItem } from "../types";

export const MatchesPagination = ({
  show,
  page,
  totalPages,
  pageItems,
  onPageChange,
  endOfListMessage,
}: {
  show: boolean;
  page: number;
  totalPages: number;
  pageItems: PaginationItem[];
  onPageChange: (nextPage: number) => void;
  endOfListMessage: string | null;
}) => {
  if (!show) return null;

  return (
    <div className="matches-pagination-section content-block">
      {totalPages > 1 && (
        <div
          className="matches-pagination"
          role="navigation"
          aria-label="Matches pages"
        >
          <button
            type="button"
            className="matches-page-nav is-prev"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 1}
            aria-label="Previous page"
          >
            <ChevronLeftIcon className="matches-page-icon" />
            <span>Previous</span>
          </button>
          <div className="matches-page-list">
            {pageItems.map((item, index) =>
              item === "ellipsis" ? (
                <span
                  key={`ellipsis-${index}`}
                  className="matches-page-ellipsis"
                  aria-hidden="true"
                >
                  ...
                </span>
              ) : (
                <button
                  key={item}
                  type="button"
                  className={`matches-page-number ${item === page ? "is-active" : ""}`}
                  onClick={() => onPageChange(item)}
                  aria-current={item === page ? "page" : undefined}
                >
                  {formatPageNumber(item)}
                </button>
              )
            )}
          </div>
          <button
            type="button"
            className="matches-page-nav is-next"
            onClick={() => onPageChange(page + 1)}
            disabled={page >= totalPages}
            aria-label="Next page"
          >
            <span>Next</span>
            <ChevronRightIcon className="matches-page-icon" />
          </button>
        </div>
      )}

      {endOfListMessage && <div className="matches-end">{endOfListMessage}</div>}
    </div>
  );
};
